"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var BillPaymentResource = /** @class */ (function (_super) {
    tslib_1.__extends(BillPaymentResource, _super);
    function BillPaymentResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillPaymentResource.endpoint = '/bps';
    BillPaymentResource.MODEL_NAME = 'billpayment';
    return BillPaymentResource;
}(index_1.BaseTransactionResource));
exports.default = BillPaymentResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/bp/index.js
// module id = Hyc5
// module chunks = 0